import _toConsumableArray from "C:/mydata/code/local.lzj/sportman/admin/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
// 创建 el-menu-item
export function elMenuItem(h, menu) {
  return h('el-menu-item', {
    key: menu.path,
    props: {
      index: menu.path
    }
  }, [].concat(_toConsumableArray(menu.icon ? [h('i', {
    attrs: {
      class: "fa fa-".concat(menu.icon)
    }
  })] : []), _toConsumableArray(menu.icon === undefined & !menu.iconSvg ? [h('i', {
    attrs: {
      class: 'fa fa-file-o'
    }
  })] : []), _toConsumableArray(menu.iconSvg ? [h('d2-icon-svg', {
    props: {
      name: menu.iconSvg
    }
  })] : []), [h('span', {
    slot: 'title'
  }, menu.title || '未命名菜单')]));
}

// 创建 el-submenu
export function elSubmenu(h, menu) {
  var _this = this;
  return h('el-submenu', {
    key: menu.path,
    props: {
      index: menu.path
    }
  }, [].concat(_toConsumableArray(menu.icon ? [h('i', {
    slot: 'title',
    attrs: {
      class: "fa fa-".concat(menu.icon)
    }
  })] : []), _toConsumableArray(menu.icon === undefined & !menu.iconSvg ? [h('i', {
    slot: 'title',
    attrs: {
      class: 'fa fa-folder-o'
    }
  })] : []), _toConsumableArray(menu.iconSvg ? [h('d2-icon-svg', {
    slot: 'title',
    props: {
      name: menu.iconSvg
    }
  })] : []), [h('span', {
    slot: 'title'
  }, menu.title || '未命名菜单')], _toConsumableArray(menu.children.map(function (child, childIndex) {
    return (child.children === undefined ? elMenuItem : elSubmenu).call(_this, h, child);
  }))));
}